import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import Details from '../../../../Interview/DetailsNew.js';
import { useSelector } from 'react-redux';
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'


const ClosingCostFeeModal = ({
    show,
    onHide,
    filterParams,
    selectedLoan,
    detailedCard,
    closingCostsDetail,
    detailType,
    statsigSource,
    // isExporting,
    // onExport
}) => {
    // console.log('closing cost fee modal', selectedLoan);
    // const selectedLoan_origin = useSelector(state => state.application.selection.selectedloan);
    // if(!selectedLoan){
    //     selectedLoan = selectedLoan_origin;
    // }
    const [isExporting, setIsExporting] = useState(false);

    const exportPDF = () => {
        if (statsigSource === 'rates') {
            track(STATSIG.RATES.VIEW_FEE_SHEET_BUTTON, 'export', { type: 'export' })
        }
        setIsExporting(true);
        
        import('jspdf').then(({ default: jsPDF }) => {
            import('html2canvas').then(({ default: html2canvas }) => {
                const pdf = new jsPDF('p', 'mm', 'a4');
                const detailsComponent = document.querySelector('.loandetails .modal-body');
                
                if (!detailsComponent) {
                    console.error('Could not find Details component');
                    setIsExporting(false);
                    return;
                }
                
                const tabLinks = detailsComponent.parentElement.querySelectorAll('.nav-link');
                
                // Always switch to Closing Cost Details tab first
                tabLinks[0].click();
                
                // Wait a bit for the first tab to render
                setTimeout(() => {
                    const closingCostDetails = detailsComponent.querySelector('.tab-pane.active');
                    
                    html2canvas(closingCostDetails).then(canvas => {
                        const imgData = canvas.toDataURL('image/png');
                        const imgWidth = 210; // A4 width in mm
                        const imgHeight = canvas.height * imgWidth / canvas.width;

                        // Add "Closing Cost Details" title for the first page
                        pdf.setFontSize(18);
                        pdf.setFont(undefined, 'bold');
                        pdf.text('Closing Cost Details', 105, 20, { align: 'center' });
                        
                        pdf.addImage(imgData, 'PNG', 0, 30, imgWidth, imgHeight);
                        
                        // Second page - Overview Page
                        // pdf.addPage();
                        
                        // Add "Loan Overview" title
                        // pdf.setFontSize(18);
                        // pdf.setFont(undefined, 'bold');
                        // pdf.text('Loan Overview', 105, 20, { align: 'center' });
                        
                        // Switch to Overview tab
                        // tabLinks[1].click();
                        
                        // setTimeout(() => {
                        //     const overviewTab = detailsComponent.querySelector('.tab-pane.active');
                            
                        //     html2canvas(overviewTab).then(canvas2 => {
                        //         const imgData2 = canvas2.toDataURL('image/png');
                        //         const imgHeight2 = canvas2.height * imgWidth / canvas2.width;
                                
                        //         pdf.addImage(imgData2, 'PNG', 0, 30, imgWidth, imgHeight2);
                                
                        //         // Save the PDF
                                pdf.save('Estimated Fee Sheet.pdf');
                                setIsExporting(false);
                        //     }).catch(err => {
                        //         console.error('Error generating PDF:', err);
                        //         setIsExporting(false);
                        //     });
                        // }, 300);
                    }).catch(err => {
                        console.error('Error generating PDF:', err);
                        setIsExporting(false);
                    });
                }, 300);
            }).catch(err => {
                console.error('Error importing html2canvas:', err);
                setIsExporting(false);
            });
        }).catch(err => {
            console.error('Error importing jsPDF:', err);
            setIsExporting(false);
        });
    };
    return (
        <Modal 
            show={show} 
            dialogClassName="loandetails mt-5"
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex justify-content-between w-100">
                    <div style={{
                        fontSize: 24, 
                        fontWeight: 'bold', 
                        color: 'white', 
                        fontFamily: 'Inter'
                    }}>
                        Estimated Fee Sheet
                    </div>
                    <div className="d-flex align-items-center">
                        <Button 
                            variant="secondary" 
                            onClick={() => exportPDF()} 
                            className="mr-auto"
                        >
                            {isExporting ? <Spinner animation='border' size='sm'/> : 'Export'}
                        </Button>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Details 
                    filterParams={filterParams}
                    selection={{...selectedLoan, estimatedclosingcosts: detailedCard.closing_costs_detail}}
                    card={{...detailedCard, estimatedclosingcosts: {...detailedCard.closing_costs_detail, closingcostsfinanced: 0, deposit: 0, fundsforborrower: 0, sellerscredits: 0, adjustmentsothercredits: 0}, prepaids: detailedCard.closing_costs_detail?.prepaids}}
                    closingCostsDetail={detailType === 'all' ? closingCostsDetail : null}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ClosingCostFeeModal;
